import React from 'react'
import mainContext from '../../contexts/mainContext';
import { getRolesListing } from '../../Controllers/RoleManagement';
import styled from '@emotion/styled';
import Button from '@mui/material/Button';
import LoopIcon from '@mui/icons-material/Loop';
import { __constants, __snackBarText, __snackBarSeverity } from '../../constants';
import moment from 'moment';
import AddEditRole from './AddEditRole';

export default function Roles() {
    /* States for components */
    const { setSnackBar, setProfileNavTitle,setPageload } = React.useContext(mainContext);
    const [state, setState] = React.useState({ supportRoles: [], total: 0, load: true, error: null })
    const [currentState, setCurrentState] = React.useState({ openModal: false, index: -1, roles: [] })

    React.useEffect(() => {
        fetchUsers()
        setProfileNavTitle("Roles");
        // eslint-disable-next-line
    }, [])

    const fetchUsers = async () => { /* Fetch all registered users */
    setPageload(true)
        const res = await getRolesListing();
        setPageload(false)
        if (res.data.status === 200) {
            setState({ ...state, ...res.data.data, load: false })
        } else {
            setState({ ...state, load: false, error: res.data.message })
        }
    }

    const onAddOrUpdate = ({ data, index }) => {
        let temp = [...state.supportRoles]
        if (index !== -1) {
            temp[index] = data
        } else {
            temp.unshift(data)
        }
        setState({ ...state, supportRoles: temp })
    }

    return (
        <>
            <Conatiner className='scrollbar'>
                <Header>
                    <Button variant="contained" size='small' onClick={() => setCurrentState({ ...currentState, openModal: true })}>Add new role</Button>
                </Header>
                <Body>
                    <List className='list_header'>
                        <div>Status</div>
                        <div>Role</div>
                        <div>Permissions</div>
                        <div>Registered On</div>
                        <div>Last Updated</div>
                        <div style={{ display: "flex", justifyContent: "flex-end" }}><LoopIcon onClick={fetchUsers} className="pointer" /></div>
                    </List>
                    {
                        state.supportRoles.map((e, index) => {
                            return (
                                <List key={e._id}>
                                    <div>
                                        <div className={`list_card_status ${e.status === "Active" ? "status_active" : "status_inactive"}`}>{e.status}</div>
                                    </div>
                                    <div>{e.role}</div>
                                    <div>{e.permissions.map((object, index) => <span>{object.name} {e.permissions.length - 1 !== (index) && " , "}</span>)}</div>
                                    <div>{moment(e.createdAt).format("MMM DD, YYYY")}</div>
                                    <div>{moment(e.updatedAt).format("MMM DD, YYYY")}</div>
                                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                        <button className="list_card_view_btn" onClick={() => setCurrentState({ ...currentState, openModal: true, ...e, index: index })}>Edit</button>
                                    </div>
                                </List>
                            )
                        })
                    }
                </Body>
            </Conatiner>

            {/* Add/Edit Role modal */}
            {currentState.openModal && <AddEditRole onAddOrUpdate={onAddOrUpdate} state={currentState} setState={setCurrentState} />}
        </>
    )
}

const Conatiner = styled("div")`
  overflow-x: auto;
  margin-bottom: 1rem;
    .input{
      margin-bottom: 5%;
      width: 100%;
    }
    button{
      text-transform: none;
    }
`;

const Header = styled("div")`
  button{
    border-radius: 5px;
  }
`;
const Body = styled("div")`
  margin-top: 1rem;
  height: 80vh;
  min-width: 1000px;
`;

const List = styled("div")`
  font-size: 80%;
  margin: 1rem 0;
  display: grid;
  grid-template-columns: 1.5fr 2fr 5fr 2fr 1.5fr 2fr;
  align-items: center;
  column-gap: 0.5rem;
`;
